module.exports = __webpack_public_path__ + "static/media/whatsapp.203adbe4.png";